import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AllData } from '../entites/allData';
import { BadgeData } from '../entites/badgeData';
import { BadgeImg } from '../entites/badgeImg';
import { LeaderBoardResult } from '../entites/leaderBoardResult';
import { Player } from '../entites/player';
import { PlayerData } from '../entites/playerData';
import { Progression } from '../entites/progression';
import { ProgressionResult } from '../entites/progressionResult';
import { Question } from '../entites/question';
import { Result } from '../entites/result';
import { Share } from '../entites/share';
import { Constants } from '../utils/constants';

@Injectable()
export class AgefiphService {

    public dataApiUrl = environment.apiUrl + '/service';

    private readyImageSource = new Subject<boolean>();
    readyImage$ = this.readyImageSource.asObservable();

    authError = false;

    animationBadge1;
    animationLogo;
    animationLoading;
    animationBadgeAccueil;

    eval1 = false;
    eval2 = false;
    eval3 = false;

    appReady = false;

    datas = new AllData();

    evaluationData = new Progression();
    compteName = '';
    playerUuid = "";
    slug: string;

    tableauBilan = new Array();

    showPopupReponse = new Subject<boolean>();
    showPopupReponse$ = this.showPopupReponse.asObservable();

    repSelectedSubject = new Subject<string>();
    repSelected$ = this.repSelectedSubject.asObservable();

    repQCUMSelectedSubject = new Subject<boolean>();
    repQCUMSelected$ = this.repQCUMSelectedSubject.asObservable();

    resizeSubject = new Subject<boolean>();
    resizeSubject$ = this.resizeSubject.asObservable();

    showPopupCompteSubject = new Subject<boolean>();
    showPopupCompteSubject$ = this.showPopupCompteSubject.asObservable();

    succes = false;
    heightZoom = 100;

    rep = [1, 2, 3, 4, 5, 6];

    revoir = false;

    index = 0;
    q = new Question();

    repQCUMSelected = ['0', '0', '0', '0', '0', '0'];
    repSelected = null;

    activeValidation = false;

    orientation = 'portrait';

    typeRep = '_text';
    nbRep = 0;
    arrayNbRep = [];
    badUid = false;
    player = new Player();
    playerData = new PlayerData();

    urlPartage = '';
    currentUrl = '';
    previousUrl = '';
    initialHeight = 0;
    whereToGo = '';
    turnMobile = false;

    firstLoad = true;

    nbBonneRep3 = 0;

    constructor(private http: HttpClient,
        private titleService: Title,
        public route: ActivatedRoute,
        public router: Router,
        public location: Location) {
        this.resize();
        this.initialHeight = window.innerHeight;
        this.currentUrl = this.router.url;
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
            };
        });

        //this.tableauBilan = [[["Au service ressources humaines"], false, "Q01", ["E"], 3, "Je suis…"], [["Les troubles musculosquelettiques (TMS)"], false, "Q02", ["D"], 1, "Parmi les maladies suivantes, quelles sont celles qui peuvent être reconnues comme un handicap ?"], [["Vrai"], true, "Q03", ["B"], 1, "Lorsqu'un chauffeur poids lourd perd l'usage d'un bras, il ne peut plus continuer à exercer son métier et doit se reconvertir."], [["Une entreprise qui emploie en majorité des personnes handicapées et leur permet de développer leurs compétences "], true, "Q04", ["C"], 1, "Qu'est-ce qu'une \"Entreprise adaptée\" (EA) ?"], [["Le triathlon"], false, "Q05", ["C"], 1, "Quel sport pratique l'athlète handisport Théo Curin ?"], [["D'en parler à son responsable ou à la direction des ressources humaines"], false, "Q06", ["D"], 2, "Si un collègue en situation de handicap se sent en difficulté dans son travail, je lui conseille… "], [["Demander à la médecine du travail un aménagement d'horaire"], true, "Q07", ["C"], 2, "Mon collègue handicapé doit recevoir des soins tôt le matin. Je lui conseille de…"], [["Je tente d'établir un dialogue."], true, "Q08", ["A"], 2, "Un collègue, ayant déjà connu des épisodes de dépression, s'isole et communique de moins en moins avec l'équipe…"], [["Rattraper le temps perdu en redoublant d'effort"], false, "Q09", ["C"], 2, "Une collègue s'apprête à reprendre son poste après un arrêt maladie de longue durée, je lui conseille de…"], [["Je la laisse faire et je m'adapte"], false, "Q10", ["A"], 2, "Une collègue qui présente des troubles du spectre autistique (TSA) a tendance à parler très fort durant les réunions d'équipe et à couper systématiquement la parole…"], [["Je prends l'initiative de faire une partie de son travail afin de la soulager"], false, "Q11", ["C"], 2, "Une collègue vient de m'annoncer qu'elle a un cancer…"], [["Je lui apporte mon aide uniquement si il me le demande"], true, "Q12", ["A"], 2, "Si l'un de mes collègue est en fauteuil roulant…"], [["Lui envoyer, avant une réunion, une version accessible des supports qui seront présentés"], false, "Q13", ["B"], 3, "Si l'un de mes collègues a un handicap visuel, je suis prêt à… "], [["Indiquer simplement aux participants ses contraintes "], false, "Q14", ["A"], 3, "Lors d'une réunion à laquelle participe une collègue sourde, je suis prêt à…"], [["L'aider et l'accompagner pour lui permettre de gagner en autonomie dans son travail"], false, "Q15", ["C"], 3, "Dans le cadre d'une collaboration sur un projet avec un collègue handicapé psychique, je suis prêt à…"]];

    }

    public getPreviousUrl() {
        return this.previousUrl;
    }

    public getCurrentUrl() {
        return this.currentUrl;
    }

    resize() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && (window.orientation === 90 || window.orientation === -90)) {
            this.turnMobile = true;
        } else if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && window.innerHeight < this.initialHeight) {
            const metaViewport = document.querySelector('meta[name=viewport]')
            metaViewport.setAttribute('content', 'height=' + this.initialHeight + 'px, width=device-width, initial-scale=1.0');
            this.turnMobile = false;
        } else if (window.innerHeight < window.innerWidth) {
            this.orientation = 'landscape';
            this.turnMobile = false;
        } else {
            this.orientation = 'portrait';
            this.turnMobile = false;
        }
        this.resizeSubject.next(true);
    }

    retour() {
        if (this.router.url.includes('retour')) {
            this.location.historyGo(-2);
        } else if (this.whereToGo) {
            this.router.navigate(['/' + this.slug + '/' + this.whereToGo]);
            this.whereToGo = '';
        } else {
            this.location.back();
        }
    }

    blockUrl() {
        if (this.router.url.includes('bilan') ||
            this.router.url.includes('accueil')
            || this.router.url.includes('resultat')
        ) {
            this.router.navigate(['/' + this.slug + '/mon-compte']);
        }
    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
        if (!route.params.slug) {
            this.appReady = true;
            return true;
        } else {
            this.slug = route.params.slug;
            if (this.datas.data !== undefined) {
                localStorage.setItem('slug', this.slug);
                return true;
            } else {
                if (this.slug !== window.localStorage.getItem("slug")) {
                    localStorage.setItem('slug', this.slug);
                    window.localStorage.setItem("playerUuid", "");
                }
                return this.getData();
            }
        }
    }

    getData(): Observable<boolean> {
        this.playerUuid = window.localStorage.getItem("playerUuid");
        this.showPopupCompteSubject.next(false);
        return this.getAllData().pipe(map(res => {
            this.datas = res;
            if (res.success) {
                this.q = this.datas.data.questions[this.index];
                this.badUid = false;
                this.preloadImages(this.datas.data.assets, 0, this.okImage);
                setTimeout(() => {
                    this.appReady = true;
                    this.player.companyUid = this.slug;
                    this.player.playerUuid = this.playerUuid;
                    this.setPlayer(this.player).subscribe(player => {
                        if (player.success) {
                            this.setCompte(player);
                            this.compteName = this.datas.data.wordings['ui.accueil.text.welcome'].replace('#playerName', this.playerData.data.pseudo);
                            if (this.playerUuid) {
                                this.blockUrl();
                            } else {
                                this.router.navigate(['/' + this.slug + '/accueil']);
                            }
                        }
                    });
                }, 1000);
                return true;
            } else {
                this.badUid = true;
                this.appReady = false;
                this.readyImageSource.next(false);
                return false;
            }
        }, () => {
            this.badUid = true;
            this.appReady = false;
            this.readyImageSource.next(false);
            return this.appReady;
        }));
    }

    okImage(parent) {
        parent.readyImageSource.next(true);
    }


    preloadImages(sources, i, callback) {
        const self = this;

        function loadNextImage() {
            if (i < sources.length - 1) {
                self.preloadImages(sources, i + 1, callback);
            } else {
                callback(self);
            }
        }
        function onload() {
            loadNextImage();
        }

        function onerror() {
            console.log('ERREUR CHARGEMENT IMAGE : ' + sources[i]);
            loadNextImage();
        }

        const img = document.createElement('img');
        if (sources[i].length > 37) {
            img.src = environment.apiUrl + '/app/' + sources[i];
        } else {
            img.src = sources[i];
        }
        img.onload = onload;
        img.onerror = onerror;
    }

    setCompte(player: PlayerData) {
        window.localStorage.setItem("playerUuid", player.data.uuid);
        this.playerUuid = player.data.uuid;
        this.playerData = player;
    }

    getAllData(): Observable<AllData> {
        //return this.http.get<AllData>('assets/json/data.json');
        return this.http.post<AllData>(this.dataApiUrl + '/getData', { companyUid: this.slug }, Constants.HttpOptions);
    }

    getLeaderBoard(): Observable<LeaderBoardResult> {
        return this.http.post<LeaderBoardResult>(this.dataApiUrl + '/getLeaderboards',
            { playerUuid: this.playerUuid, companyUid: this.slug }, Constants.HttpOptions);
    }

    getProgression(): Observable<ProgressionResult> {
        return this.http.post<ProgressionResult>(this.dataApiUrl + '/getProgression',
            { playerUuid: this.playerUuid }, Constants.HttpOptions);
    }

    logShare(plateform: string): Observable<Share> {
        return this.http.post<Share>(this.dataApiUrl + '/logShare',
            { playerUuid: this.playerUuid, platform: plateform }, Constants.HttpOptions);
    }

    saveEvaluation(): Observable<LeaderBoardResult> {
        return this.http.post<LeaderBoardResult>(this.dataApiUrl + '/saveEvaluation',
            { playerUuid: this.playerUuid, evaluationData: JSON.stringify(this.evaluationData) }, Constants.HttpOptions);
    }

    generateBadge(badgeData: BadgeData): Observable<BadgeImg> {
        return this.http.post<BadgeImg>(this.dataApiUrl + '/generateBadgeShareUrl',
            { playerUuid: this.playerUuid, badgeData: JSON.stringify(badgeData) }, Constants.HttpOptions);
    }

    setPlayer(player: Player): Observable<PlayerData> {
        return this.http.post<PlayerData>(this.dataApiUrl + '/setPlayer',
            JSON.stringify(player), Constants.HttpOptions);
    }

    resetPassword(email: string): Observable<Result> {
        return this.http.post<Result>(this.dataApiUrl + '/resetPassword',
            { email: email }, Constants.HttpOptions);
    }

    auth(action: number, params: string[]): Observable<PlayerData> {
        return this.http.post<PlayerData>(this.dataApiUrl + '/auth',
            { action: action, params: JSON.stringify(params) }, Constants.HttpOptions);
    }

    generateNonce(): string {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 12; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }

    setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }
}
